import { Directive, ElementRef } from '@angular/core';
/**
 * Generated class for the RemoveHostDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[remove-host]' // Attribute selector
})
export class RemoveHostDirective {
  constructor(private el: ElementRef) {
  }

  //wait for the component to render completely
  ngOnInit() {
      //console.log('ngOnInit');
      var nativeElement: HTMLElement = this.el.nativeElement,
          parentElement: HTMLElement = nativeElement.parentElement;

        //console.log('parent: ' + parentElement.nodeName);
      // move all children out of the element
      while (nativeElement.firstChild) {
          console.log('inserting ' + nativeElement.firstChild.nodeName);
          parentElement.insertBefore(nativeElement.firstChild, nativeElement);
      }
      // remove the empty element(the host)
      //console.log('removing: ' + nativeElement.nodeName);
      parentElement.removeChild(nativeElement);
  }
}